import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../lib/api';

const TilbakestillPassord = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const nav = useNavigate();
  const [passord, setPassord] = useState('');
  const [bekreft, setBekreft] = useState('');
  const [busy, setBusy] = useState(false);
  const [feil, setFeil] = useState('');
  const [ok, setOk] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setFeil('');
    if (passord.length < 8) { setFeil('Passordet må være minst 8 tegn.'); return; }
    if (passord !== bekreft) { setFeil('Passordene er ikke like.'); return; }
    setBusy(true);
    try {
      await api.post('/auth/tilbakestill-passord', { token, passord });
      setOk(true);
      setTimeout(() => nav('/login'), 2500);
    } catch (err) {
      setFeil(err.response?.data?.error || 'Kunne ikke tilbakestille passordet.');
    } finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: 'var(--theme-bg-primary)', padding: 16 }}>
      <div className="card" style={{ width: '100%', maxWidth: 380, padding: 28 }}>
        <div className="flex items-center justify-center" style={{ marginBottom: 20 }}>
          <img src="/logo.png" alt="REGNINO" style={{ height: 48, width: 'auto', maxWidth: '100%', objectFit: 'contain' }} />
        </div>
        <h2 style={{ textAlign: 'center', marginBottom: 14, fontSize: 18 }}>Sett nytt passord</h2>
        {!token ? (
          <div className="badge badge-danger" style={{ width: '100%', justifyContent: 'center', padding: 10 }}>
            Mangler token. Be om en ny lenke fra <Link to="/glemt-passord">glemt passord</Link>.
          </div>
        ) : ok ? (
          <>
            <div className="badge badge-success" style={{ width: '100%', justifyContent: 'center', padding: 10, marginBottom: 12 }}>
              Passordet er oppdatert. Sender deg til innlogging…
            </div>
            <div style={{ textAlign: 'center', fontSize: 13 }}>
              <Link to="/login">Logg inn nå</Link>
            </div>
          </>
        ) : (
          <form onSubmit={onSubmit}>
            <label>Nytt passord</label>
            <input type="password" value={passord} onChange={(e) => setPassord(e.target.value)}
                   autoFocus required minLength={8} style={{ marginBottom: 10 }} />
            <label>Bekreft passord</label>
            <input type="password" value={bekreft} onChange={(e) => setBekreft(e.target.value)}
                   required minLength={8} style={{ marginBottom: 10 }} />
            {feil && (
              <div className="badge badge-danger" style={{ width: '100%', justifyContent: 'center', padding: 8, marginBottom: 12 }}>
                {feil}
              </div>
            )}
            <button type="submit" disabled={busy} className="btn-primary"
                    style={{ width: '100%', height: 36, justifyContent: 'center' }}>
              {busy ? 'Lagrer…' : 'Sett nytt passord'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default TilbakestillPassord;
